<template>
  <div class="app-container forward">
    <div v-show="!showLoading">
      <div class="post-item">
        <post-item
          :acc="obj.acc"
          :title="obj.title"
          :isShowTransfer="false"
          :time="obj.createTime"
          :icon="obj.image"
          :source="obj.source"
          :source-self-acc="obj.sourceSelf && obj.sourceSelf.acc ? obj.sourceSelf.acc : null"
          :resource="obj"
        />
      </div>
      <div class="content">
        <div class="left">
          <span>点击量:</span>
          <span class="view">{{ obj.viewVisit || 0 }}</span>
          <van-button
            class="item-btn"
            type="primary"
            plain
            size="small"
            @click="$router.push({ path: '/cms-detail-list?acc=' + acc })"
          >
            看明细
          </van-button>
        </div>
        <div class="left">
          <span>阅读量:</span>
          <span class="view">{{ obj.valUnique || 0 }}</span>
        </div>
        <div class="right">
          <div>首次点击：{{ obj.firstHitTime | formatDateTime('YYYY-MM-DD HH:mm') }}</div>
          <div>末次点击：{{ obj.lastHitTime | formatDateTime('YYYY-MM-DD HH:mm') }}</div>
        </div>
      </div>
      <div class="rule note" v-if="obj.parentInfo && obj.parentInfo.statusCtrl === 2">
        <van-icon name="warning" color="#ee0a24" size="60" />
        <p>该期“热词”已超过转发分享时限，无法再获取收益。</p>
        <p>感谢您的大力支持！</p>
        <p>请前往转发分享最近几期“热词”</p>
      </div>
      <div class="rule" v-else>
        <span class="title">转发规则</span>
        <div class="rule-box">
          <p>1、在<b>本页面</b>点击右上角的“…”，分享到朋友圈</p>
          <p><img src="../assets/shuo.png" /></p>
          <p>2、好友点击你的链接后，你会获得+1点击量和阅读量，好友重复点击只会增加点击量，不增加阅读量</p>
          <p v-if="awardRules[0]">
            3、当你获得的阅读量满{{ awardRules[0].numMatch }}可获得{{ awardRules[0].valAward }}元<span
              v-if="awardRules[1]"
              >，满{{ awardRules[1].numMatch }}追加{{ awardRules[1].valAward }}元</span
            >
          </p>
          <p>4、分享有效期为60天，超过分享时限无法再获取奖励。</p>
          <p style="color: red">注意：直接在原文分享，将无法记录分享动作。</p>
        </div>
      </div>
    </div>
    <div class="loading-wrap" v-show="showLoading" @click="redirectToSource">
      <van-loading class="loading" type="spinner" color="#1989fa" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Loading } from 'vant';
import postItem from '@/components/PostItem';
import { source, hitSourceAsync } from '@/api/cms';
import { formatDateTime } from '@/filters';
import wechatUtil from '@/utils/wechatUtil';
import { imgPath } from '@/utils/constant';
import { getToken, getUid } from '@/utils/auth';
import { getSetting } from '@/api/user';
const prefix = process.env.VUE_APP_STORE_PREFIX;

Vue.use(Loading);
export default {
  name: 'toTransfer',
  components: { postItem },
  filters: { formatDateTime },
  data() {
    return {
      acc: '',
      obj: {},
      awardRules: [],
      showLoading: true,
      redirectSource: '',
      isPageHide: false,
      awardNumRead: 0
    };
  },
  created() {
    // 解决 ios 回退不会对页面再次刷新问题
    window.addEventListener('pageshow', e => {
      console.log('%c [ 监听到 pageshow ]: ', 'color:#1989fa;', this.isPageHide);
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        console.log('%c [ ios 刷新页面 111 ]: ', 'color:#1989fa;', e.persisted);
        if (e.persisted === true && this.isPageHide === true) {
          console.log('%c [ ios 刷新页面 222 ]: ', 'color:#1989fa;');
          window.location.reload();
        }
      }
    });
    window.addEventListener('pagehide', () => {
      console.log('%c [ 监听到 pagehide ]: ', 'color:#1989fa;');
      this.isPageHide = true;
    });
  },
  mounted() {
    console.log('*** 分享页 ***');
    if (this.$route.params.acc) {
      this.acc = this.$route.params.acc;
      this.getSource(this.acc);
    }
    this.getSettingJson();
  },
  methods: {
    async getSource(acc) {
      const params = {
        acc
      };
      try {
        const { data } = await source(params);
        const d = data.pub.source;
        if (Array.isArray(d.awardRules)) {
          this.awardRules = d.awardRules;
        }
        console.log('%c<<<<<<< d >>>>>>>', 'color:#f90', d);
        const isNotRedirect = await this.handleRedirect(d);
        if (isNotRedirect) {
          console.log('%c [不用重定向]: ', 'color:#1989fa;');
          this.showLoading = false;
          this.obj = d;
          this.handleShare(d);
        }
      } catch (e) {
        throw new Error(e);
      }
    },
    // 分享
    handleShare(data) {
      const { title, image, description } = data;
      console.log('%c [share title]: ', 'color:#1989fa;', title);
      document.title = title;
      const imgUrl = imgPath + image;
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        console.log('%c [ios 设备]: ', 'color:#1989fa;');
        wechatUtil.updateAppMessageShareData(title, imgUrl, description);
        wechatUtil.updateTimelineShareData(title, imgUrl, description);
      } else {
        console.log('%c [android 设备]: ', 'color:#1989fa;');
        // eslint-disable-next-line no-unused-vars
        wechatUtil.init().then((wx, res) => {
          console.log('%c [android init ok]: ', 'color:#1989fa;');
          wechatUtil.updateAppMessageShareData(title, imgUrl, description);
          wechatUtil.updateTimelineShareData(title, imgUrl, description);
        });
      }
    },
    // 处理重定向逻辑
    async handleRedirect(data) {
      const { uid, source, acc, parent } = data;
      if (getUid() !== uid || !getToken()) {
        console.log('%c [重定向到原文]: ', 'color:#1989fa;', uid, source);
        try {
          const form = {
            acc
          };
          const checkExitParent = this.checkExitParent(parent);
          if (checkExitParent === true) {
            console.log('%c [你是游客 不增加点击量 重定向到原文]: ', 'color:#1989fa;');
            // 转发页过滤机制调整 https://www.teambition.com/task/61a49ae17e41e9003f9188ba
            form.isIgnore = true;
            await hitSourceAsync({ form });
            // alert('你是游客 不增加点击量 重定向到原文');
            setTimeout(() => {
              this.redirectSource = source;
              location.replace(source);
            }, 100);
          } else {
            console.log('%c [你是游客 不存在这个 parent 增加点击量 并重定向原文]: ', 'color:#1989fa;');
            // alert('你是游客 不存在这个 parent 增加点击量 并重定向原文');
            try {
              const res = await hitSourceAsync({ form });
              if (res) {
                this.storeParentToMap(parent);
              }
            } catch (e) {
              console.error('hitSourceAsync error', e);
            }

            setTimeout(() => {
              this.redirectSource = source;
              location.replace(source);
            }, 100);
          }
        } catch (e) {
          throw new Error(e);
        }
        return false;
      } else {
        return true;
      }
    },
    getParentMap() {
      const parentMapString = localStorage.getItem(`${prefix}parent-map`);
      let parentMap = {};
      if (parentMapString) {
        parentMap = JSON.parse(parentMapString);
      }
      console.log('%c [parentMap 000]: ', 'color:#1989fa;', parentMap);
      return parentMap;
    },
    // 初始化查询是否已经有 parent 模板id
    checkExitParent(parent) {
      let parentMap = this.getParentMap();
      console.log('%c [checkExitParent 000 ]: ', 'color:#1989fa;', parentMap[parent]);
      if (!parentMap[parent]) {
        parentMap[parent] = 0;
        localStorage.setItem(`${prefix}parent-map`, JSON.stringify(parentMap));
        console.log('%c [没有分享过]: ', 'color:#1989fa;', JSON.stringify(parentMap));
        console.log('%c [没有分享过]: ', 'color:#1989fa;', parent + '没有分享过' + '值设为 0,并保存, 增加点击量');
        // alert(parent + '没有分享过' + '值设为 0,并保存, 增加点击量');
        return false;
      }
      if (parentMap[parent] && parentMap[parent] > 0) {
        console.log('%c [已经分享过了 不增加点击量]: ', 'color:#1989fa;');
        // alert('已经分享过了, 不增加点击量');
        return true;
      }
    },
    // 存储的 parent 模板id value 改为 1
    storeParentToMap(parent) {
      let parentMap = this.getParentMap();
      parentMap[parent] = 1;
      // alert(parent + '的值改为 1,并保存');
      console.log('%c []: ', 'color:#1989fa;', parent + '的值改为 1,并保存');
      console.log('%c [存储 parent 模板id 000]: ', 'color:#1989fa;', JSON.stringify(parentMap));
      localStorage.setItem(`${prefix}parent-map`, JSON.stringify(parentMap));
    },
    redirectToSource() {
      location.replace(this.redirectSource);
    },
    async getSettingJson() {
      try {
        const { data } = await getSetting();
        const settings = JSON.parse(data.pub.getSettingBusinessJson);
        console.log('%c [this.settings]: ', 'color:#1989fa;', settings);
        this.awardNumRead = settings.AwardNumRead;
      } catch (e) {
        throw new Error(e);
      }
    }
  }
};
</script>

<style scoped lang="less">
.forward {
  min-height: 100vh;
  position: relative;
  background: #fff;
  .content {
    background: linear-gradient(0deg, rgba(255, 255, 255, 1), #f5f5f5);
    padding: 0 15px;
    display: flex;
    font-size: 14px;
    color: #333;
    .left {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      flex: 1;
      .view {
        font-size: 30px;
        color: #1989fa;
        font-weight: bolder;
      }
    }
    .right {
      align-items: center;
      text-align: right;
      color: #666;
    }
  }
  .rule {
    text-align: left;
    background-color: #fff;
    padding: 15px;
    .title {
      font-size: 18px;
      color: #444;
      font-weight: bold;
      border-bottom: 3px solid #1989fa;
    }
    .rule-box {
      font-size: 15px;
      color: #333;
      line-height: 1.5;
      margin-top: 15px;
      text-align: justify;
      p {
        margin-bottom: 10px;
      }
      img {
        width: 110px;
        margin: auto;
        display: block;
      }
    }
  }
  .note {
    text-align: center;
    font-size: 15px;
    line-height: 2;
    color: #333;
  }
  .loading-wrap {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
  }
}
.post-item {
  padding: 15px 15px;
  background: #f5f5f5;
}
</style>
